/* eslint-disable no-param-reassign */
import { dataGet } from '@fps/vue-toolkit/dist/util';
import isArray from 'lodash-es/isArray';
import store from '@/store';

function getRequestCategoryFilters(state) {
  const value = [];

  // Category & subcategory
  if (state.subcategory) {
    value.push({
      property: 'category.id',
      operator: '=',
      value: state.subcategory.id,
    });
  } else if (state.category) {
    value.push({
      property: 'categoryFilter',
      operator: 'scope',
      value: state.category.id || '',
    });
  }

  return value;
}

function getRequestSearchFilters(state) {
  const value = [];

  if (state.search && !state.keywordMatchedCategory) {
    value.push({
      property: 'keywordFilter',
      operator: 'scope',
      value: state.search,
    });
  }

  let location = null;
  // eslint-disable-next-line no-cond-assign
  if (state.location && (location = dataGet('location.geometry.location', state))) { // && state.radius) {
    value.push({
      property: 'locationFilter',
      operator: 'scope',
      value: {
        longitude: location.lng(),
        latitude: location.lat(),
        // radius: state.radius.value,
        radius: 100,
      },
    });
  }
  return value;
}

function getRequestAttributeFilters(state) {
  let value = [];

  const dynamicKeys = Object.keys(state.dynamic);
  if (state.dynamic && dynamicKeys.length) {
    const dynamicValue = dynamicKeys
      .filter(key => state.dynamic[key]
        && state.dynamic[key].value
        && !state.dynamic[key].type.column_filter)
      .map(key => (
        {
          type: state.dynamic[key].type.type,
          attribute_type_id: state.dynamic[key].type.id,
          value: state.dynamic[key].value,
        }
      ));
    if (dynamicValue.length) {
      value.push({
        property: 'attributeFilter',
        operator: 'scope',
        value: { fields: dynamicValue },
      });
    }

    dynamicKeys
      .filter(key => state.dynamic[key]
        && state.dynamic[key].value
        && state.dynamic[key].type.column_filter)
      .forEach((key) => {
        const atType = state.dynamic[key].type;
        const atValue = state.dynamic[key].value;
        value = [
          ...value,
          ...(atType.type === 'range' ? [
            { property: state.dynamic[key].type.key, operator: '>=', value: atValue[0] },
            { property: state.dynamic[key].type.key, operator: '<=', value: atValue[1] },
          ] : [
            { property: state.dynamic[key].type.key, operator: state.dynamic[key].type.operator || '=', value: atValue.value },
          ]),
        ];
      });
  }

  return value;
}


export function getAttributeTypes(state) {
  const translation = store.state.locale;

  const mapTypeDataParsed = attr => attr.map(atType => ({
    ...atType,
    type_data_parsed: atType.type_data_parsed && isArray(atType.type_data_parsed) ?
      atType.type_data_parsed
        .map((typeData) => {
          if (typeData && typeData.translations) {
            typeData.name = typeData.translations[translation];
          }
          return typeData;
        }) : atType.type_data_parsed,
  }));

  if (state.subcategory && state.subcategory.key) {
    if (state.subcategory && state.subcategory.key.split('_')[0] === 'others') {
      return mapTypeDataParsed((state.subcategory.attribute_types || []));
    }
  }

  const categoryAttributeTypes = state.category ? state.category.attribute_types || [] : [];
  return mapTypeDataParsed((state.subcategory && state.subcategory.attribute_types) ?
    categoryAttributeTypes.concat(state.subcategory.attribute_types) :
    categoryAttributeTypes);
}

export function getFillableAttributeTypes(state) {
  return getAttributeTypes(state)
    // Filter to contain only attributes that can be filled for the current configuration
    .filter(item => !item.column_filter);
}

export default {
  getCategory: state =>
    paypload => state.filters.categories.find(category => category.key === paypload),

  getRequestCategoryFilters,

  getRequestSearchFilters,

  getRequestAttributeFilters,

  getRequestFilters(state) {
    const value = [{
      property: 'active',
      operator: '=',
      value: true,
    },
    ...getRequestCategoryFilters(state),
    ...getRequestSearchFilters(state),
    ...getRequestAttributeFilters(state),
    ];

    return value;
  },

  getRequestSorts(state) {
    const sort = [];
    switch (state.sort) {
      case 'newest': sort.push(['publish_date', 'desc']); break;
      case 'oldest': sort.push(['publish_date', 'asc']); break;
      case 'price_low': sort.push(['price', 'asc']); break;
      case 'price_high': sort.push(['price', 'desc']); break;
      default: sort.push(['publish_date', 'desc']); break;
    }

    return sort;
  },

  attributeTypes: getAttributeTypes,
};



// WEBPACK FOOTER //
// ./src/store/filters/filters.getters.js